import React, { ChangeEvent, useEffect, useState } from 'react';

import { Grid, Paper } from '@mui/material';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';

import AnalyzerSelect from '../analyzers/AnalyzerSelect';

import {
  sendScpiCommand,
  selectMessage,
} from '../spectrasWebSocketServer/spectrasWebSocketServerSlice';

import { Alert } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import useInLightMode from '../../hooks/useInLightMode';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';

const ConsolePage = () => {
  const inLightMode = useInLightMode();
  const dispatch = useAppDispatch();
  const { data: analyzers } = useAnalyzers({});
  const { selectedAnalyzerId } = useAppSelector((state) => state.analyzers);

  const message = useAppSelector(selectMessage);

  const { data: selectedAnalyzer } = useAnalyzer({
    analyzerId: selectedAnalyzerId,
  });

  const [scpiCommand, setScpiCommand] = useState('');
  const [scpiResponse, setScpiResponse] = useState('');

  const handleScpiCommandChange = (event: ChangeEvent<HTMLInputElement>) => {
    setScpiCommand(event.target.value);
  };

  const sendConsoleCommand = () => {
    if (!selectedAnalyzer) return;
    dispatch(
      sendScpiCommand({
        analyzer: selectedAnalyzer,
        scpiCommand: scpiCommand,
      })
    );
    setScpiResponse((prevState) => prevState + `> ${scpiCommand}\n`);
  };

  const handleEnterKeyPressed = (
    event: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (event.charCode === 13) {
      sendConsoleCommand();
    }
  };

  useEffect(() => {
    if (!selectedAnalyzer?.id) return;
    const response = message[selectedAnalyzer.id]?.message;
    if (response) {
      setScpiResponse((prevState) => prevState + `${response}\n`);
    }
  }, [message, selectedAnalyzer?.id]);

  useEffect(() => {
    setScpiResponse('');
  }, [selectedAnalyzerId]);

  return (
    <Grid container>
      <Grid
        style={{ margin: 0, padding: 0 }}
        item
        container
        spacing={2}
        component={Paper}
      >
        <Grid item xs={1}>
          <AnalyzerSelect
            analyzers={analyzers}
            selectedAnalyzerId={selectedAnalyzerId}
          />
        </Grid>
        {selectedAnalyzer && selectedAnalyzer?.mode !== 0 && (
          <Grid item xs={12} style={{ marginRight: '1rem' }}>
            <Alert severity='error'>
              Analyzer needs to be in live mode to use the console.
            </Alert>
          </Grid>
        )}
        <Grid item xs={12} style={{ marginRight: '1rem' }}>
          <TextField
            fullWidth
            multiline
            rows={20}
            value={scpiResponse}
          ></TextField>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={1}
          style={{ paddingBottom: '1rem' }}
        >
          <Grid item>
            <TextField
              variant='outlined'
              size='small'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'></InputAdornment>
                ),
              }}
              onChange={handleScpiCommandChange}
              onKeyPress={handleEnterKeyPressed}
              value={scpiCommand}
              style={{
                background: inLightMode ? undefined : '#2e2e2e',
                borderRadius: '10px',
              }}
              disabled={selectedAnalyzer?.mode !== 0}
            />
          </Grid>
          <Grid item>
            <Button
              disabled={selectedAnalyzer?.mode !== 0}
              variant='contained'
              onClick={sendConsoleCommand}
            >
              Send
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={selectedAnalyzer?.mode !== 0}
              variant='contained'
              onClick={() => setScpiResponse('')}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ConsolePage;
